import { Component, OnInit, ViewChild } from "@angular/core";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { LmsService } from "../../_Lms/services/lms.service";
import { LosService } from "../../_LOS/services/los.service";
import { Router } from "@angular/router";
import { PartnerService } from "../services/partner.service";


@Component({
  selector: 'app-partner-modify-booking-list',
  templateUrl: './partner-modify-booking-list.component.html',
  styleUrls: ['./partner-modify-booking-list.component.scss']
})
export class PartnerModifyBookingListComponent implements OnInit {
  currentUser: any;
  showSpinner: boolean = false;
  dataSourceLoan: any;
  displayedColumnsLoan: string[] = [];
  AcCatgList: any = [];
  ACCCategoryType: any = 0;
  Loan_Acc_Type: any = 'Co-Lending';
  LoanStatus: any = 'Live'
  Customer: any = {};
  SelectType: any = "";
  BranchesList: any = [];
  SalesExecutiveData: any = [];
  CollectionExecutiveData: any = [];
  SourceAreaData: any = [];
  areaData: any = [];
  collectionArea: any = [];
  subAreaData: any = [];
  DealerList: any[] = [];
  partneLoanNo: any;
  partnerDropdown: any;
  LeadSourceName: string;
  leadSourceDropdown: any;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;


  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  constructor(
    private lmsService: LmsService,
    private losService: LosService,
    private _Partnerservice: PartnerService,
    private dataSharingService: DataSharingService,
    private snackBar: MatSnackBar,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.dataSharingService.HeaderTitle.next("Modify Booking List");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    //this.onSearchPartnerModifyBookingList();
    this.Customer.CloseCase = "";
    this.onChangeType();
    this.getBranchesList();
    this.GetCollectionExecutive();
    this.GetSalesExecutive();
    this.getAreaByUserId();
    this.getSubAreaByUserId();
    this.getDealerList();
    this.Get_PartnerForDropdown();
    this.getLeadSourceDropdown();
  }

  onSearchPartnerModifyBookingList() {
    this.showSpinner = true;
    this.displayedColumnsLoan = [
      "LoanId", "Partner_LoanAcNo", "LMS_LoanAcNo", "LoanCreatedOn", "Application_No", "Customer", "Branch", "Product", "LoanAMount",
      "EMIAmount", "DueDate", "Loan_Acc_Category", "Action"
    ];
    this.Customer.IsClose = this.LoanStatus == 'Live' ? 0 : 1,
      this._Partnerservice.Partner_Get_ModifyBooking_List({
        LoginUserId: this.currentUser.userId, LoanAccCateoryId: this.ACCCategoryType,
        JSON: JSON.stringify(this.Customer)
      })
        .subscribe((res: any) => {
          //console.log(res);
          this.dataSourceLoan = null;
          if (res.length > 0) {
            this.dataSourceLoan = new MatTableDataSource(JSON.parse(JSON.stringify(res)));
            this.dataSourceLoan.sort = this.sort;
            this.dataSourceLoan.paginator = this.paginator;
          }
          this.showSpinner = false;
        });
  }

  applyFilter(filterValue: string) {
    this.dataSourceLoan.filter = filterValue.trim().toLowerCase();
  }

  exportTable(exporter: any) {
    exporter.exportTable("xls", {
      fileName: `Partner-ModifyBooking-list`,
      sheet: "Partner-ModifyBooking-list",
    });
  }

  goToDetailLoan(data: any) {
    this.router.navigate([
      `/partner-dashboard/loan-info/${encodeURIComponent(data.LoanId)}/${"A"}`,
    ]);
  }

  onChangeType() {
    this.ACCCategoryType = 0;
    this.lmsService.Get_ACC_Category_ForDropdown_By_Type({ Type: this.Loan_Acc_Type }).subscribe((result) => {
      this.AcCatgList = JSON.parse(JSON.stringify(result));

    });
  }

  SearchChange() {
    this.Customer = {
      CloseCase: "",
      BranchId: "",
      Area: "",
      SubArea: "",
      SalesEx: "",
      CollectionEx: "",
      LoanAccountingCatId: "",
      SourceId: "",
      SourceType: "",
    };
  }

  getLeadSourceDropdown() {
    this.showSpinner = true;
    this.losService.getLeadSourceDropdown({}).subscribe((res: any) => {
      this.leadSourceDropdown = res;
      // console.log("Lead Source Dropdown", this.leadSourceDropdown);
      this.showSpinner = false;
    });
  }

  Get_PartnerForDropdown() {
    // console.log("Partner Dropdown API Function");

    if (
      this.Customer.SourceType == "Agent" ||
      this.Customer.SourceType == "DSA" ||
      this.Customer.SourceType == "Dealer"
    ) {
      // console.log("if condition logggg");
      this.losService
        .Get_PartnerForDropdown({
          PartnerType: this.Customer.SourceType,
          branchId: 0,
        })
        .subscribe((res: any) => {
          this.partnerDropdown = res;
          // console.log("Partner dropdown", this.partnerDropdown);
        });
    } else if (this.Customer.SourceType == "Sales Executive") {
      this.partnerDropdown = [];
      this.SalesExecutiveData.forEach((obj: any) => {
        this.partnerDropdown.push({
          PartnerId: obj.EmpId,
          Partner_Name: obj.EmpName,
        });
      });
    } else {
      this.LeadSourceName = "";
    }
    this.LeadSourceName = "";
  }

  getBranchesList() {
    this.lmsService
      .GetBranches({ Emp_Id: this.currentUser.userId })
      .subscribe((result) => {
        this.BranchesList = JSON.parse(JSON.stringify(result));
      });
  }

  GetCollectionExecutive() {
    this.lmsService
      .Get_Collection_Ex_By_UserId({
        LoginUserId: this.currentUser.userId,
        BranchId: "",
      })
      .subscribe((res) => {
        this.CollectionExecutiveData = JSON.parse(JSON.stringify(res));
      });
  }

  GetSalesExecutive() {
    this.lmsService
      .Get_Collection_Ex_By_UserId({
        LoginUserId: this.currentUser.userId,
        BranchId: "",
      })
      .subscribe((res) => {
        this.SalesExecutiveData = JSON.parse(JSON.stringify(res));
      });
  }

  getAreaByUserId() {
    this.lmsService
      .Get_Area_By_UserId({
        BranchId: "",
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        this.areaData = JSON.parse(JSON.stringify(res));
      });
  }
  getDealerList() {
    this.lmsService.GET_Partner_List({ Type: "Dealer" }).subscribe((result) => {
      this.DealerList = JSON.parse(JSON.stringify(result));
    });
  }

  getSubAreaByUserId() {
    this.lmsService
      .Get_SubArea_By_UserId({
        BranchId: "",
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        this.subAreaData = JSON.parse(JSON.stringify(res));
      });
  }
}
